import { INVOICE_ROW_UPDATE } from '../mutationTypes';

const initState = {
  activeRow: {},
};
const getters = {};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  [INVOICE_ROW_UPDATE](states, newValue = initState.activeRow) {
    const activeRow = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { activeRow });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
